import { useAuth0 } from "@auth0/auth0-react";
import Button from "components/button/Button";
import AlertDialog from "components/Dialog";
import { InputField } from "components/InputField";
import UserService from "Lib/API/users/index";
import React, { useCallback, useEffect, useState } from "react";
import { toastr } from "react-redux-toastr";
import { useHistory } from "react-router-dom";
import ConvenienceFeeAmount from "./ConvenienceFeeAmount";
import LedgerList from "./LedgerList";
import TypeCheckBoxes from "./PaymentCheckBox";
import PaymentGatewaySelection from "./PaymentGatewaySelection";

const EditPaymentType = ({
  formik,
  type,
  addNew,
  edit,
  updateFunc,
  createFunc,
  setEdit,
  setDaisableAddNew,
  setDisable,
  setAddNew,
}) => {
  const { push } = useHistory();
  const { getAccessTokenSilently } = useAuth0();

  const [openDisableAlert, setOpenDisableAlert] = useState(false);
  const [paymentGateways, setPaymentGateways] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const handleCloseDialog = () => {
    setOpenDisableAlert(false);
  };
  const handleCancel = (e) => {
    setOpenDisableAlert(false);
    e.preventDefault();

  formik.resetForm();
    push({
      pathname: "/financial-setting/payment-types/view",
    });
  };
  const cancelFunc = () => {
    setOpenDisableAlert(true);
  };
  const validateCreateFunc = () => {
    if (!formik.values?.payement_type_new) {
      return toastr.info("Validation", "Text field is mandatory");
    }
    if (formik?.values?.coverConvenienceFee) {
      if (!formik?.values?.convenienceFeeInfo?.amount || formik?.values?.convenienceFeeInfo?.amount < 0.01) {
        return toastr.info("Validation", "Please enter a valid amount");
      } else if (!formik?.values?.convenienceFeeInfo?.ledger?.id) {
        return toastr.info("Validation", "Please select a ledger");
      }
    }
    createFunc();
    push({
      pathname: "/financial-setting/payment-types/view",
    });
  };
  const validateUpdateFunc = () => {
    if (!formik.values?.payement_type_new) {
      return toastr.info("Validation", "Text field is mandatory");
    }
    if (formik?.values?.coverConvenienceFee) {
      if (!formik?.values?.convenienceFeeInfo?.amount || formik?.values?.convenienceFeeInfo?.amount < 0.01) {
        return toastr.info("Validation", "Please enter a valid amount");
      } else if (!formik?.values?.convenienceFeeInfo?.ledger?.id) {
        return toastr.info("Validation", "Please select a ledger");
      }
    }
    if((formik.values?.payement_type_new === "ach" || formik.values?.payement_type_new === "credit card") && !formik.values?.paymentGateway){
      return toastr.info("Validation", "Please select a payment gateway");
    }
    const payload = {
      ...(!validate ? { type: formik.values?.payement_type_new } : {}),
      is_default: formik.values?.default_payment_type,
      allow_member: formik?.values?.allow_member,
      coverConvenienceFee: formik?.values?.coverConvenienceFee,
      allowInstallment: formik?.values?.allowInstallment,
      allowMemberInstallment: formik?.values?.allowMemberInstallment,
      paymentGateway: formik?.values?.paymentGateway?.value ? formik?.values?.paymentGateway?.value : undefined,
    }
    if (formik?.values?.coverConvenienceFee) {
      payload.convenienceFeeInfo = {
        amount: formik?.values?.convenienceFeeInfo?.amount,
        type: formik?.values?.convenienceFeeInfo?.type,
        ledger: formik?.values?.convenienceFeeInfo?.ledger,
            optional: formik?.values?.optionalConvenienceFee,

        message: formik?.values?.optionalConvenienceFee

          ? formik?.values?.optionalConvenienceFeeInfo

              ?.optionalConvenienceFeeMessage

          : undefined,

      
      }
      if (formik?.values?.convenienceFeeInfo?.subLedger?.id) {
        payload.convenienceFeeInfo.subLedger = formik?.values?.convenienceFeeInfo?.subLedger
      }
    }

    updateFunc(payload);
    push({
      pathname: "/financial-setting/payment-types/view",
    });
  };
  const validate =
    formik.values?.payement_type_new === "cash" ||
    formik.values?.payement_type_new === "credit card" ||
    formik.values?.payement_type_new === "check" ||
    formik.values?.payement_type_new === "credit on account" ||
    formik.values?.payement_type_new === "ach";


  const getPaymentGatewaysHandler = useCallback(async () => {
    setIsLoading(true);
    const token = await getAccessTokenSilently();
    UserService.getPaymentGateways({ token })
      .then((response) => {
        const filteredPaymentGateways = (response?.result || [])
        .map(({ title, provider }) => ({
          value: title,
          label: title,
          provider,
        }));
        setPaymentGateways(filteredPaymentGateways);
      })
      .catch((err) => {
        toastr.error("Error", err?.data?.message || "Something went wrong");
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, []);


  useEffect(() => {
    if (formik.values?.payement_type_new === "ach" || formik.values?.payement_type_new === "credit card") {
      getPaymentGatewaysHandler();
    }
  }
    , [formik.values?.payement_type_new]);
    

   
   const filteredPaymentGetaways = () => {
    if(!formik.values?.allow_member) return paymentGateways;
    return paymentGateways.filter(item => item.provider === "Stripe");
   }


  return (
    <div className="pl-5 ml-5">
       <div className="d-flex justify-content-end pr-15">
        <AlertDialog
          open={openDisableAlert}
          handleClose={handleCloseDialog}
          onDecline={() => {
            setOpenDisableAlert(false);
          }}
          onAccept={handleCancel}
          title={" Are you sure?"}
          description={"Do you want to discard the changes you made?"}
        />
        <Button
          onClick={cancelFunc}
          variant="primary-outline"
          size="md"
          style={{ minWidth: 80 }}
        >
          Cancel
        </Button>
        <Button
          className="ml-5"
          onClick={addNew == true ? validateCreateFunc : validateUpdateFunc}
          variant="primary"
          size="md"
          style={{ minWidth: 80 }}
            disabled={

            formik?.values?.coverConvenienceFee&&

            formik.values?.optionalConvenienceFee &&

            formik.values?.optionalConvenienceFeeInfo

              ?.optionalConvenienceFeeMessage === ""

          }
        >
          Save
        </Button>
      </div>
      <div className="col-md-4">
        {validate ? (
          ""
        ) : (
          <InputField
            mandatory={true}
            {...{
              formik,
              name: "payement_type_new",
              title: "Payment Type Title",
            }}
            value={formik.values?.payement_type_new}
            style={{ height: "48px" }}
          />
        )}
      </div>
      {(formik.values?.payement_type_new === "ach" || formik.values?.payement_type_new === "credit card") && (
        <PaymentGatewaySelection 
          options={filteredPaymentGetaways()}
          formik={formik}
          isLoading={isLoading}
        />
      )}
      <div className="payment_setting_checkbox">
        <TypeCheckBoxes addNew={addNew} formik={formik} edit={edit} />
      </div>
       {formik.values?.optionalConvenienceFee &&

        formik.values?.coverConvenienceFee && (

          <div className="d-flex p-5 flex-column convenience-wrapper">

            <InputField

              formik={formik}

              name={`optionalConvenienceFeeInfo.optionalConvenienceFeeMessage`}

              mandatory={true}

              title="Message"

              placeholder="Enter message (Max. 100 characters)"

              value={

                formik.values?.optionalConvenienceFeeInfo

                  ?.optionalConvenienceFeeMessage

              }

              onChange={(e) => {

                formik.setFieldValue(

                  `optionalConvenienceFeeInfo.optionalConvenienceFeeMessage`,

                  e.target.value

                );

              }}

              maxLength={100}

              multiline

              rows={3}

              style={{ width: "100%" }}

            />

          </div>

        )
        }
      {formik.values?.coverConvenienceFee && (
        <div className="d-flex p-5 flex-column convenience-wrapper">
          <ConvenienceFeeAmount formik={formik} />
          <LedgerList formik={formik} />
        </div>
      )}
     
    </div>
  );
};

export default EditPaymentType;
